import React from "react";

export const ContactCardList: React.FC<{ children: React.ReactNode }> = props => (
    <ul className="2xl:grid 2xl:grid-cols-2 2xl:gap-4 mt-4 space-y-4 2xl:space-y-0">
        {props.children}
    </ul>
);

export const ContactCardListItem: React.FC<{ children: React.ReactNode }> = props => (
    <li className="min-w-0 border border-gray-200 rounded-lg p-4">{props.children}</li>
);
